import { useTranslation } from 'react-i18next';
import type { TocItem } from '@/hooks/useBlogDetail';

export default function BlogTableOfContents({ toc }: { toc: TocItem[] }) {
  const { t } = useTranslation();

  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <aside className="flex w-full flex-col gap-3 rounded-xl bg-white p-4 shadow-[0_0_40px_0_rgba(0,0,0,0.06)] lg:p-5">
      <h2 className="text-[12px] font-bold leading-[1.3] tracking-[0.14px] text-secondary-900">
        {t('blog.tableOfContents')}
      </h2>
      <div className="h-px w-full bg-secondary-100" />
      <ul className="flex flex-col">
        {toc.map((item, i) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => handleClick(item.id)}
              className="flex w-full items-center py-3 text-left text-[12px] font-medium text-secondary-700 transition-colors hover:text-primary-600"
            >
              {item.text}
            </button>
            {i < toc.length - 1 && (
              <div className="h-px w-full bg-secondary-100" />
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}